import styled from "styled-components"
import { theme } from "Theme"

export const Content = styled.div`
  display: block;
  padding: 0 0 1rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  max-width: ${theme.layout.base};
  overflow: visible;

  @media (min-width: ${theme.breakpoints.s}) {
    padding: 0 0 1rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export const Title = styled.h2`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  overflow: hidden;
  // &:before {
  //   content: '';
  //   display: inline-block;
  //   height: 0.5em;
  //   vertical-align: bottom;
  //   width: 100%;
  //   margin-right: 10px;
  //   margin-left: -100%;
  //   border-top: 1px solid black;
  // }
  &:after {
    content: "";
    display: inline-block;
    height: 0.5em;
    vertical-align: bottom;
    width: 100%;
    margin-right: -100%;
    margin-left: 10px;
    border-top: 1px solid #aaa;
  }
`

export const Subtitle = styled.p`
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  & + a {
    margin-top: 1rem;
  }
  text-align: left;
`
